import React from 'react';
import '../styles/RiderHiringAnnouncement.css';

const RiderHiringAnnouncement = () => {
    const handleDownloadClick = (e) => {
        e.preventDefault();

        const riderSection = document.getElementById('rider-app-section');

        if (riderSection) {
            riderSection.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });

            riderSection.classList.add('rider-qr-highlight');

            setTimeout(() => {
                riderSection.classList.remove('rider-qr-highlight');
            }, 2500);
        }
    };

    return (
        <div className="rider-hiring-announcement">
            <div className="rider-hiring-track">
                <span className="rider-hiring-item">
                    🏍️
                    <strong>We are hiring riders!</strong>
                    <span>Please join Vinirji and start earning with us.</span>

                    <a
                        href="#rider-app-section"
                        onClick={handleDownloadClick}
                    >
                        Download Rider App →
                    </a>
                </span>
                 {/* Sales Executive Recruitment */}
            <span className="rider-hiring-item">
                💼
                <strong>We are hiring Sales Executives!</strong>
                <span>Join Vinirji and grow with us.</span>

                <a href="tel:+917093383463">
                    Contact: +91 7093383463
                </a>
            </span>

                <span className="rider-hiring-item" aria-hidden="true">
                    🛵<strong>We are hiring riders!</strong>
                    <span>Please join Vinirji and start earning with us.</span>

                    <a href="#rider-app-section" onClick={handleDownloadClick} tabIndex="-1">
                        Download Rider App →
                    </a>
                </span>
                 {/* Sales Manager Recruitment */}
            <span className="rider-hiring-item">
                💼
                <strong>We are hiring Sales Executives!</strong>
                <span>Join Vinirji and grow with us.</span>

                <a href="tel:+917093383463">
                    Contact: +91 7093383463
                </a>
            </span>
            </div>
        </div>
    );
};

export default RiderHiringAnnouncement;